<template>
    <div class="flex w-full flex-col">
        <AppList
            :items="references"
            :filterFn="filterFn"
            @removeItem="remove"
            @navigateTo="navigateTo"
            :removable="!readOnly"
            class="max-w-5xl"
            :line-height="50"
            :new-item-label="$t('project.follow.planning.newReference')"
            @newItem="createNewReferencePopup"
        >
            <template v-slot:item="{ item }">
                <div>
                    <span class="text-lg font-bold mx-1">{{ item.name }}</span>
                    <span class="text-xs text-gray-700">{{ item.createdAt | humanizeDate }}</span>
                </div>
            </template>
        </AppList>
        <app-popup
            ref="popup"
            :showHeader="true"
            :title="$t('project.follow.planning.newReference')"
            popup-extra-class="p-10"
        >
            <div class="flex flex-col p-2 gap-2">
                <app-checkbox
                    v-model="isDefinedRefDate"
                    :label="$t('project.follow.planning.refDateOption')"
                ></app-checkbox>
                <app-date-input
                    v-if="isDefinedRefDate"
                    v-model="newRefDate"
                    :label="$t('project.follow.planning.refDate')"
                >
                    <template v-slot:tip>
                        <span class="text-sm italic text-gray text-gray-700">
                            {{ $t('project.follow.planning.newRefDateTips') }}
                        </span>
                    </template>
                </app-date-input>
            </div>
            <app-footer @click="createNewReference()" class="mt-2 p-2" :label="$t('commons.ok')"></app-footer>
        </app-popup>
    </div>
</template>

<script>
import { confirm } from '../../dialogs/dialogs.service';
import { getReferences, removeReference, createReference } from './references.service';
import AppList from '../../../components/appList/AppList';
import { error } from '@/features/toasts/toats.service';
import { queryProject } from '@/features/projects/projects.service';
import { getPlannedTasks } from '@/features/tasks/plannedTasks.service';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import AppPopup from '@/components/app-popup/AppPopup.vue';
import AppDateInput from '@/components/appDateInput/AppDateInput.vue';
import { queryPlanningState } from '@/state/state';
import AppCheckbox from '@/components/app-checkbox/AppCheckbox.vue';
import AppFooter from '@/components/appFooter/AppFooter.vue';

export default {
    components: { AppFooter, AppCheckbox, AppDateInput, AppPopup, AppList },
    created() {
        this.subscriptions = [
            getReferences(this.$route.params.projectId).subscribe((references) => {
                this.references = references;
            }),
        ];
        queryProject(this.$route.params.projectId).then((project) => {
            this.readOnly = !project.me.allowedFeatures.includes('project_planning');
            const planningState = queryPlanningState(this.$route.params.projectId);
            this.newRefDate = planningState.refDate
                ? new Date(planningState.refDate)
                : project.startDate
                ? new Date(project.startDate)
                : new Date();
        });
    },
    methods: {
        createNewReferencePopup() {
            this.$refs.popup.open();
        },
        async createNewReference() {
            this.$refs.popup.close();
            const tasks = await firstValueFrom(
                getPlannedTasks(this.$route.params.projectId, new BehaviorSubject(this.newRefDate)),
            );
            if (tasks.length === 0) {
                error(this.$t('project.follow.planning.newReferenceDisabledWhenNoTasks'));
            } else {
                return createReference(this.$route.params.projectId, {
                    name:
                        this.$t('project.follow.planning.newReferenceNamePrefix') + ' ' + (this.references.length + 1),
                    dates: tasks.map((task) => {
                        return {
                            taskId: task.id,
                            startDate: task.startDate?.toISOString(),
                            endDate: task.endDate?.toISOString(),
                        };
                    }),
                });
            }
        },
        filterFn(filter) {
            if (filter.length > 0) {
                return this.references.filter(({ name }) => name.includes(filter));
            } else {
                return this.references;
            }
        },
        async remove(reference) {
            if (await confirm(this.$t('project.follow.references.confirmMessage'))) {
                await removeReference(this.$route.params.projectId, reference.id);
            }
        },
        navigateTo: function (event) {
            this.$router.push({
                name: 'reference',
                params: { projectId: this.$route.params.projectId, referenceId: event.id },
            });
        },
    },
    data() {
        return {
            newRefDate: new Date(),
            references: [],
            readOnly: false,
            subscriptions: [],
            isDefinedRefDate: false,
        };
    },
};
</script>
